import styled from 'styled-components'

import colors from '@galo-monitor/styles/colors'

export const Container = styled.div`
  height: auto;
  width: auto;

  display: flex;
  flex-direction: column;
`

export const RadioGroupContainer = styled.div`
  height: auto;
  width: auto;

  display: flex;
  flex-direction: row;
`

export const Label = styled.span`
  font-size: ${ props => props.size === 'small' ? '0.75rem' : '16px' };
  font-weight: 600;
  margin-bottom: 8px;
  color: ${ props => props.size === 'small' ? colors.mutedText : colors.black };
`
